import { ObjectDataset } from "@tblabs/storage";
import { BasketFormLogic } from "../Components/OrderForm/BasketFormLogic";
import { Basket } from "./Basket/Basket";
import { Discounter } from "./Basket/Discounter";
import { BasketLocalStorage } from "./Basket/Storage/BasketLocalStorage";
import { ShopContentProvider } from "./Content/ShopContentProvider";
import { Ticket } from "../Models/OrderTicket/Ticket";
import { BasketToTicketConverter } from "../Components/OrderForm/FormInfoToTicketConverter";
import { Notifier } from "./Notifier/Notifier";
import { AppConfig } from "../AppConfig";


export class BasketProvider
{
    private basket?: Basket;
    private basketBrain?: BasketFormLogic;

    constructor(
        private _shop: ShopContentProvider,
        private _tickets: ObjectDataset<Ticket>,
        private _notifier: Notifier,
        private _appConfig: AppConfig)
    { }

    public get Basket(): Basket
    {
        if (!this.basket)
        {
            throw new Error('Basket not loaded');
        }

        return this.basket;
    }

    public get BasketBrain(): BasketFormLogic
    {
        if (!this.basketBrain)
        {
            throw new Error('Basket brain not loaded');
        }

        return this.basketBrain;
    }

    public async Send(): Promise<string>
    {
        const converter = new BasketToTicketConverter();
        const ticket = converter.Convert(this.BasketBrain);

        await this._tickets.Add(ticket.Id, ticket);
        await this._notifier.OrderCreated(ticket);

        this.basket?.Clear();

        const orderUrl = this._appConfig.GetOrderUrl(ticket.Id);

        return orderUrl;
    }

    public async Load(): Promise<void>
    {
        if (this.basket)
        {
            return;
        }

        const basketStorage = new BasketLocalStorage();
        const basketConfig = this._shop.Shop.BasketOptions;
        const discounter = new Discounter(basketConfig);
        const products = this._shop.Shop.Products.Items;

        this.basket = new Basket(basketStorage, products, basketConfig, discounter);
        this.basketBrain = new BasketFormLogic(this.basket);
    }
}
